import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeSmallCtaSkeleton } from "./TypeSmallCta";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeFeaturedProjectsSection'
 * @name TypeFeaturedProjectsSectionFields
 * @type {TypeFeaturedProjectsSectionFields}
 * @memberof TypeFeaturedProjectsSection
 */
export interface TypeFeaturedProjectsSectionFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized false
     */
    header?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'subHeader' (Sub Header)
     * @name Sub Header
     * @localized false
     */
    subHeader?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'description' (Description)
     * @name Description
     * @localized false
     */
    description?: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'backgroundColor' (Background Color)
     * @name Background Color
     * @localized false
     */
    backgroundColor?: EntryFieldTypes.Symbol<"grey" | "light-blue" | "white">;
    /**
     * Field type definition for field 'cta' (CTA)
     * @name CTA
     * @localized false
     */
    cta?: EntryFieldTypes.EntryLink<TypeSmallCtaSkeleton>;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'featuredProjectsSection' (Featured Projects Section)
 * @name TypeFeaturedProjectsSectionSkeleton
 * @type {TypeFeaturedProjectsSectionSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-24T18:36:34.693Z
 * @version 13
 */
export type TypeFeaturedProjectsSectionSkeleton = EntrySkeletonType<TypeFeaturedProjectsSectionFields, "featuredProjectsSection">;
/**
 * Entry type definition for content type 'featuredProjectsSection' (Featured Projects Section)
 * @name TypeFeaturedProjectsSection
 * @type {TypeFeaturedProjectsSection}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-24T18:36:34.693Z
 * @version 13
 */
export type TypeFeaturedProjectsSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeFeaturedProjectsSectionSkeleton, Modifiers, Locales>;

export function isTypeFeaturedProjectsSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeFeaturedProjectsSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'featuredProjectsSection'
}
